(function($) {
  var cartPopupSelector = '.addcart';
  
  $('form[action="/cart/add"]').submit(function(e) {
    e.preventDefault();
    var $form = $(this);
    var $addToCartButton = $form.find('[data-add-to-cart]');
    var originalButtonText = $addToCartButton.text();
    var formData = $form.serialize();
    conslole.log(formData,'formData');

    $addToCartButton.text('Adding to cart...').attr('disabled', true);
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: formData,
      dataType: 'json',
      success: function(data) {
        //$addToCartButton.text('Add to cart').attr('disabled', false);
        if (typeof showAjaxifiedCartPopup === 'function') {
          showAjaxifiedCartPopup(data);
        } else {
          $(cartPopupSelector).fadeIn().delay(2000).fadeOut();
        }
      },
      error: function(XMLHttpRequest, textStatus) {
        $addToCartButton.text(originalButtonText).attr('disabled', false);
        alert('Error adding to cart: ' + textStatus);
      }
    });
  });
})(jQuery);